import React from 'react';

import type { RouteMatch } from '@confluence/route';

import { SmartCreateSessionLoader } from '@confluence/smart-create/entry-points/SmartCreateSession';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { fg } from '@confluence/feature-gating';

export const SmartCreateSessionRoute = (routeMatch: RouteMatch) => {
	if (!fg('confluence_ai_create_menu_item')) {
		return;
	}

	const sessionId = routeMatch?.params?.sessionId as string;
	const spaceKey = (routeMatch?.query?.spaceKey as string) || '';

	return <SmartCreateSessionLoader spaceKey={spaceKey} sessionId={sessionId} />;
};

SmartCreateSessionRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const spaceKey = routeMatch?.query?.spaceKey ?? '';
	const sessionId = routeMatch?.params?.sessionId ?? '';
	return {
		Screen: {
			screenEvent: {
				name: 'smartCreateSessionScreen',
			},
			pageState: { spaceKey, sessionId, routeName: routeMatch.name },
		},
		MainLayout: {
			spaceKey,
			navView: CONTAINER_HOME_ID,
		},
	};
};
